import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFieldsComponentsManager } from '@panneau/core/contexts';

var _excluded = ["endpoint", "action", "label", "value", "icon", "theme", "disabled", "onConfirmed", "fieldComponent", "className"];

// TODO: figure out what happens when an item / multiple items are selected

var propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  id: PropTypes.string,
  endpoint: PropTypes.string,
  action: PropTypes.func,
  // Promise
  label: PropTypes.string,
  value: PropTypes.shape({}),
  icon: PropTypes.string,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
  fieldComponent: PropTypes.string,
  onConfirmed: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  id: null,
  endpoint: '/import',
  action: null,
  label: null,
  value: null,
  icon: 'upload',
  theme: 'primary',
  disabled: false,
  fieldComponent: 'upload',
  onConfirmed: null,
  className: null
};
var ImportAction = function ImportAction(_ref) {
  _ref.endpoint;
    _ref.action;
    var label = _ref.label;
    _ref.value;
    var icon = _ref.icon,
    theme = _ref.theme,
    disabled = _ref.disabled,
    onConfirmed = _ref.onConfirmed,
    fieldComponent = _ref.fieldComponent,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var FieldComponents = useFieldsComponentsManager();
  var FieldComponent = FieldComponents.getComponent(fieldComponent);
  var onComplete = useCallback(function (data) {
    if (onConfirmed !== null) {
      onConfirmed(data);
    }
  }, [onConfirmed]);
  return /*#__PURE__*/React.createElement(FieldComponent, Object.assign({
    withButton: true,
    outline: false,
    theme: theme,
    addButtonIcon: icon,
    addButtonLabel: label || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "eL+nIp",
      defaultMessage: [{
        "type": 0,
        "value": "Add file"
      }]
    }),
    onChange: onComplete,
    disabled: disabled,
    className: className
  }, props));
};
ImportAction.propTypes = propTypes;
ImportAction.defaultProps = defaultProps;

export { ImportAction as default };
